<template>
  <el-container >
    <el-main>
      <el-row  justify="space-start" :gutter="20">
        
        <el-col :span="24">
          <el-card class="box-card">
            <h4 class="card-title">Manage Classrooms</h4>
            <div class="card-header">


              <div class="card-content">
                
                <el-row style="margin-top:30px; margin-bottom: 10px">
                  <el-col :span="12" style="">
                      <classroom-filter
                      :filter="classrooms"
                    
                      v-model="classrooms"
                      v-on:loading="loading = $event"
                      v-on:total="total = $event"
                      v-on:days="days = $event"
                      v-on:update:classrooms="classrooms = $event"
                    >
                    </classroom-filter>
                  </el-col>
             
                  <el-col :offset="4" :span="8" class="alignright">
                    <el-button type="primary" icon="el-icon-download" @click="classroomDownload()">Download CSV</el-button>
                    <router-link :to="'/classroom/create'">
                      <el-button type="success" icon="el-icon-plus">Create New Classroom</el-button>
                    </router-link>
                  </el-col>
                </el-row>

                <span v-if="total>0">Total: {{total}}</span>
                <div class="table-responsive">
                  <el-table
                    class="table-shopping"
                    style="width: 100%"
                    :data="classrooms"
                    :tool-bar="false"
                    :default-sort = "{prop: 'startDate', order: 'descending'}"
                    :total="total"
                    :loading="loading"
                    
                  >
                    <el-table-column type="expand">
                      <template slot-scope="props">
                        <el-col :span="24" :offset="1">
                          <i class="el-icon-loading" v-if="loading"></i>
                          <p v-if="props.row.tutor">
                            <strong>Tutor:</strong>
                            {{props.row.tutor.firstname}} {{props.row.tutor.lastname}} <router-link :to="'/tutors/edit/'+props.row.tutorId">
                                <span class="ti-new-window"></span>
                              </router-link>
                          </p>
                          <p v-if="props.row.venue && props.row.venue.name != 'Online'">
                            <strong>Venue:</strong>
                            {{props.row.venue.name}}, {{props.row.venue.line1}}, {{props.row.venue.town}} <router-link :to="'/classroom/venue/edit/'+props.row.venue.id">
                                <span class="ti-new-window"></span>
                              </router-link>
                            <br />
                          </p>
                          <p v-if="props.row.venue && props.row.venue.name == 'Online'">
                            <strong>Venue:</strong>
                             <router-link :to="'/classroom/venue/edit/'+props.row.venue.id">
                                Virtual Online Course <span class="ti-new-window"></span>
                              </router-link>
                            <br />
                          </p>
                          <p>
                            <strong>Attendees:</strong>
                            <br />
                            <el-tag
                              size="mini"
                              type="success"
                              v-for="(attendee,index) in props.row.attendees"
                              :key="index"
                            >
                              {{attendee.customer.firstname}} {{attendee.customer.lastname}}
                              <router-link :to="'/customer/edit/'+attendee.customer.id">
                                <span class="ti-new-window" style="color:#fff;"></span>
                              </router-link>
                            </el-tag>
                          </p>
                        </el-col>
                      </template>
                    </el-table-column>
                    <el-table-column label="Status" min-width="6">
                      <template slot-scope="props">
                        <span class="label label-danger" v-if="props.row.historic == '1' && props.row.isPublic == '0'">Cancelled</span>
                        <span class="label label-warning" v-if="props.row.historic != '1' && props.row.isPublic == '0'">Inactive</span>
                        <span class="label label-success" v-if="props.row.historic != '1' && props.row.isPublic == '1'">Active</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="Date" min-width="12" prop="startDate" sortable>
                      <template slot-scope="props"><strong>Start:</strong> {{props.row.startDate | moment('ddd, MMM Do, YYYY')}}<br><strong>End:</strong> {{props.row.endDate | moment('ddd, MMM Do, YYYY')}}</template>
                    </el-table-column>
                    <el-table-column label="Sessions" min-width="12" v-if="days > 3">
                      <template slot-scope="props">
                        <span v-if="props.row.code != 'flexible' && props.row.sessions">
                          <strong>Times: </strong><br>
                          {{props.row.startDate+' '+props.row.startTime | moment('ha')}} - {{props.row.startDate+' '+props.row.endTime | moment('ha')}}<br>
                          <strong>Dates: </strong><br>
                          <span v-if="props.row.sessions[0]">1) {{props.row.sessions[0] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[1]">2) {{props.row.sessions[1] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[2]">3) {{props.row.sessions[2] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[3]">4) {{props.row.sessions[3] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[4]">5) {{props.row.sessions[4] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[5]">6) {{props.row.sessions[5] | moment('ddd, MMM Do')}}</span>
                        </span>
                        <span v-if="props.row.code == 'flexible'">
                          <strong>Flexible holding course</strong>
                        </span>
                        <span v-if="!props.row.sessions">
                          <strong>No sessions</strong>
                        </span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Code" min-width="7">
                      <template slot-scope="props">{{props.row.code}}</template>
                    </el-table-column>

                    <el-table-column label="Meeting ID" min-width="8" v-if="days > 3">
                      <template slot-scope="props">
                        <span v-if="props.row.meetingID">
                          {{props.row.meetingID}}
                        </span>
                        <span v-else>
                          No meeting ID
                        </span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Meeting URL" min-width="14" v-if="days > 3">
                      <template slot-scope="props">
                        <span v-if="props.row.meetingUrl">
                          <a :href="props.row.meetingUrl">{{props.row.meetingUrl}}</a>
                        </span>
                        <span v-else>
                          No meeting URL
                        </span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Occupancy" min-width="8" prop="numAttendees" sortable align="center">
                      <template slot-scope="props">
                        <strong>{{props.row.numAttendees}} / {{props.row.maxAttendees}}</strong><br>
                        <small
                          class="label label-info"
                          v-if="props.row.maxAttendees - props.row.numAttendees === 0"
                        >Full</small>
                        <small
                          class="label label-danger"
                          v-if="props.row.numAttendees === 0"
                        >Empty</small>
                      </template>
                    </el-table-column>

                    <el-table-column label="Exchange" min-width="10" align="center">
                      <template slot-scope="props">
                        <el-checkbox v-model="props.row.canExchange">Exchange</el-checkbox><br>
                        <!--<button type="button" class="el-button el-button--info el-button--mini is-round" size="mini" @click="saveExchange(props.row.id,props.row.canExchange)">Save</button>-->
                      </template>
                    </el-table-column>

                    <el-table-column label="Venue" min-width="15" v-if="days < 4">
                      <template slot-scope="props">{{props.row.venue.name}}</template>
                    </el-table-column>

                    <el-table-column label="Town" min-width="15" v-if="days < 4">
                      <template slot-scope="props">{{props.row.venue.town}}</template>
                    </el-table-column>

                    <el-table-column label="Tutor" min-width="15" align="center">
                      <template slot-scope="props">
                        <el-select
                          size="large"
                          class="form-group border-input"
                          placeholder="Select Tutor"
                          v-model="props.row.tutorId"
                          value-key="id"
                        >
                        <el-option
                          v-for="tutor in tutors"
                          class="select-default"
                          :value="tutor.id"
                          :label="tutor.firstname + ' ' + tutor.lastname"
                          :key="tutor.id"
                        ></el-option>
                        </el-select>
                        <!--<button type="button" class="el-button el-button--info el-button--mini is-round" size="mini" @click="changeTutor(props.row.id,props.row.tutorId)">Change Tutor</button>-->
                      </template>
                    </el-table-column>

                    <el-table-column label="Notes" min-width="20" align="center">
                      <template slot-scope="props">
                        <textarea width="90%" style="width:90%" v-model="props.row.notes"></textarea><br>
                        <!--<button type="button" class="el-button el-button--info el-button--mini is-round" size="mini" @click="saveNote(props.row.id,props.row.notes)">Save Note</button>-->
                      </template>
                    </el-table-column>

                    <el-table-column min-width="5" label="Options" class="td-text">
                      <template slot-scope="props">
                        <router-link type="button" class="el-button el-button--success el-button--mini is-round" :to="'/classroom/edit/' +props.row.id">Edit</router-link><br>
                        <button type="button" class="el-button el-button--info el-button--mini is-round" style="margin-top:10px;" @click="saveChanges(props.row.id,{note: props.row.notes, tutorId: props.row.tutorId, canExchange: props.row.canExchange})">Save</button>
                      </template>
                    </el-table-column>

                  </el-table>
                </div>
              </div>
            </div>
            <div class="card-content"></div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import ClassroomFilter from "../UIComponents/ClassroomManagement.vue";

import api from "./api";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";



export default {
  components: {
    ClassroomFilter
  },
  data() {
    return {
      countries: [],
      classrooms:[],
      total:0,
      aggregate: {},
      currentPage: 1,
      pageSize: 10,
      loading: false,
      days: null,
      tutors: []
    };
  },
  methods: {

    saveChanges(id,data) {
      //note = this.stripHTML(note);
      console.log(data);
      let q = gql`
      mutation AddNote($note: String, $tutorId: Int, $canExchange: Boolean) {
        update_ClassRoom(
          where: {id: {_eq: ${id}}}, 
          _set: {
            notes: $note,
            tutorId: $tutorId,
            canExchange: $canExchange
          }
        ) 
        {
          returning {
            id
          }
        }
      }`;
      this.$apollo
        .mutate({
          mutation: q,
          variables: {
            note: data.note,
            tutorId: data.tutorId,
            canExchange: data.canExchange,
          }
        })
        .then(result => {
          console.log(result);
          this.$notify({
            title: "Updated",
            message: "Saved",
            type: "success"
        });
      });
    },

    saveNote(id,note) {
      //note = this.stripHTML(note);
      console.log(note);
      let q = gql`
      mutation AddNote($note: String) {
        update_ClassRoom(where: {id: {_eq: ${id}}}, _set: {notes: $note}) {
          returning {
            id
          }
        }
      }`;
      this.$apollo
        .mutate({
          mutation: q,
          variables: {
            note: note,
          }
        })
        .then(result => {
          console.log(result);
          this.$notify({
            title: "Updated",
            message: "Note Saved",
            type: "success"
        });
      });
    },

    changeTutor(id,tutorId) {
      //note = note.stripHTML();
      let q = gql`
      mutation changeTutor {
        update_ClassRoom(where: {id: {_eq: ${id}}}, _set: {tutorId: ${tutorId}}) {
          returning {
            id
          }
        }
      }`;
      this.$apollo
        .mutate({
          mutation: q
        })
        .then(result => {
          console.log(result);
          this.$notify({
            title: "Updated",
            message: "Tutor Saved",
            type: "success"
        });
      });
    },

    async getTutors() {
      this.$apollo
        .query({
          query: gql`
            {
              Tutor(limit: 50, where: {isActive: {_eq: 1}}, order_by: {firstname: asc}) {
                id
                firstname
                lastname
              }
            }
          `,
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.tutors = response.data.Tutor;
        });
    },
 
    classroomDownload() {
      this.csvArr = [];
      var classroom = this.classrooms;
      var sLen = this.classrooms.length;
      for (var i = 0; i < sLen; i++) {
        if(classroom[i].tutor){
          this.csvArr.push([
            classroom[i].code,
            classroom[i].startDate,
            classroom[i].endDate,
            classroom[i]['length'],
            classroom[i].maxAttendees - classroom[i].numAttendees,
            classroom[i].venue.name,
            classroom[i].venue.town,
            classroom[i].tutor.firstname + ' ' + classroom[i].tutor.lastname
          ]);
        } else {
          this.csvArr.push([
            classroom[i].code,
            classroom[i].startDate,
            classroom[i].endDate,
            classroom[i]['length'],
            classroom[i].maxAttendees - classroom[i].numAttendees,
            classroom[i].venue.name,
            classroom[i].venue.town,
            'None assigned'
          ]);  
        }
      }

      let csvContent =
        [
          [
            "Code",
            "Start Date",
            "End Date",
            "Days",
            "Places Remaining",
            "Venue Name",
            "Venue Location",
            "Tutor"
          ]
        ] + "\r";

      this.csvArr.forEach(rowArray => {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });

      var fileURL = window.URL.createObjectURL(
        new Blob([csvContent], { type: "text/csv" })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", "Classrooms.csv");
      document.body.appendChild(fileLink);
      fileLink.click();
    }
    
  },
  mounted() {
    this.getTutors();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Classrooms/Manage.vue